module.exports = __webpack_public_path__ + "d036a8c8d23d7d13d0321aff1287adac.png";